import { render, staticRenderFns } from "./ModalAlertCargaReturned.vue?vue&type=template&id=6a43bc53&scoped=true"
import script from "./ModalAlertCargaReturned.vue?vue&type=script&lang=ts"
export * from "./ModalAlertCargaReturned.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlertCargaReturned.vue?vue&type=style&index=0&id=6a43bc53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43bc53",
  null
  
)

export default component.exports